/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Icon } from './Icon';
import { Text as DefText } from './Text';
import { Title } from './Title';

const PendingSellCrypto = () => {
  const { t } = useTranslation();

  return (
    <>
      <Icon type={'successBlue'} />
      <Title>{t('NOTIFICATION_SELL_PENDING_MODAL__title')}</Title>
      <Text>{t('NOTIFICATION_SELL_PENDING_MODAL__desc')}</Text>
    </>
  );
};

const Text = styled(DefText)`
  margin-left: 0;
  margin-right: 0;
`;

export { PendingSellCrypto };
